import { put, takeLatest } from 'redux-saga/effects';
import { setUserInfo } from '../reducers/userInfoSlice';

export function* workerUserInfoSaga({ payload }) {
    yield put(setUserInfo(payload))
}

export default function* userInfoSaga() {
    yield takeLatest("userInfo/getUserInfo", workerUserInfoSaga);
}